import React, { useState, useEffect } from 'react';
import { db } from './firebase.js';
import { collection, onSnapshot, query, orderBy } from './firestore-compat';

// SettingsModal — mostra os usuários cadastrados como responsáveis possíveis.
// A lista é apenas para visualização: para adicionar responsáveis, crie usuários em Configurações > Usuários.

function SettingsModal({ isOpen, onClose }) {
  const [users, setUsers] = useState([]);
  const [search, setSearch] = useState('');

  useEffect(() => {
    if (!isOpen) return;
    // Carrega os usuários do sistema (coleção 'users')
    const q = query(collection(db, 'users'), orderBy('name'));
    const unsub = onSnapshot(q, (snap) => {
      setUsers(snap.docs.map(d => ({ id: d.id, ...d.data() })));
    });
    return () => unsub();
  }, [isOpen]);

  if (!isOpen) return null;

  const filtered = users.filter(u => {
    if (!search.trim()) return true;
    const q = search.toLowerCase();
    return (u.name || '').toLowerCase().includes(q) || (u.email || '').toLowerCase().includes(q);
  });

  return (
    <div className="modal-overlay">
      <div className="modal-content settings-modal">
        <h2>Configurações</h2>

        {/* ---- RESPONSÁVEIS (vêm dos usuários cadastrados) ---- */}
        <div className="settings-section">
          <h3>Responsáveis</h3>
          <p style={{ fontSize: '0.82rem', color: '#888', marginTop: 0, marginBottom: 12 }}>
            Os responsáveis disponíveis nas tarefas são os usuários cadastrados no sistema.
            Para adicionar ou remover, acesse <strong>Configurações &gt; Usuários e Permissões</strong>.
          </p>

          {/* Busca */}
          <input
            type="text"
            value={search}
            onChange={e => setSearch(e.target.value)}
            placeholder="Buscar usuário..."
            style={{
              width: '100%', padding: '8px 12px', borderRadius: 6,
              border: '1px solid #ddd', marginBottom: 12, fontSize: '0.88rem',
              boxSizing: 'border-box'
            }}
          />

          {/* Grid de usuários */}
          <div className="responsaveis-grid">
            {filtered.length === 0 && (
              <p style={{ color: '#aaa', fontSize: '0.82rem', fontStyle: 'italic' }}>
                {search ? `Nenhum usuário encontrado para "${search}".` : 'Nenhum usuário cadastrado.'}
              </p>
            )}
            {filtered.map(u => {
              const initials = (u.name || u.email || '?')
                .split(' ').slice(0, 2).map(w => w[0]).join('').toUpperCase();
              const colors = ['#6f42c1', '#007bff', '#28a745', '#fd7e14', '#dc3545', '#20c997', '#6c757d'];
              const color = colors[(u.name || '').charCodeAt(0) % colors.length];
              return (
                <div key={u.id} className="responsavel-chip" style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                  <div style={{
                    width: 28, height: 28, borderRadius: '50%',
                    backgroundColor: color, color: '#fff',
                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                    fontSize: '0.72rem', fontWeight: 700, flexShrink: 0
                  }}>{initials}</div>
                  <div>
                    <div style={{ fontSize: '0.85rem', fontWeight: 600, lineHeight: 1.2 }}>{u.name || '—'}</div>
                    {u.email && <div style={{ fontSize: '0.72rem', color: '#888', lineHeight: 1.2 }}>{u.email}</div>}
                  </div>
                </div>
              );
            })}
          </div>

          <p style={{ fontSize: '0.75rem', color: '#bbb', marginTop: 10 }}>
            {filtered.length} usuário{filtered.length !== 1 ? 's' : ''} encontrado{filtered.length !== 1 ? 's' : ''}.
          </p>
        </div>

        <div className="modal-actions">
          <button type="button" onClick={onClose} className="btn-save">Fechar</button>
        </div>
      </div>
    </div>
  );
}

export default SettingsModal;